import wretch from 'wretch';

export default class SubscriptionService {
  /**
   * @param {string} videoId
   * @param {lang} lang
   * @returns {object}
   */
  static async fetchVideoDetails(videoId, pageId, lang = 'en', signInRequired = false) {
    try {
      return (
        await wretch(`/web3/api/premiumcontent${signInRequired ? '/signinrequired' : ''}?id=${videoId}&pageId=${pageId}&lang=${lang}`)
          .options({ credentials: 'same-origin' })
          .get().json()
      );
    } catch (e) {
      console.error(`An error occurred while trying fetch video details: ${e}`);

      return null;
    }
  }
}
